export default {
  WAITING: 'WAITING',
  UPLOADING: 'UPLOADING',
  PROCESSING: 'PROCESSING',
  SUCCEEDED: 'SUCCEEDED',
  FAILED: 'FAILED',
};



// WEBPACK FOOTER //
// ./src/shared/constants/uploading-statuses.js